<template>
  <div
    :class="{show: isVisible}"
    class="form-group dropdown select-form-group"
  >
    <div
      v-on-clickaway="closeDropdown"
      class="input-group">
      <label
        v-if="label"
        :for="'select-' + name"
        class="control-label"
      >
        {{ label }}
      </label>
      <input
        ref="input"
        :disabled="disabled"
        :id="'select-' + name"
        :class="{'has-value': selectedValue}"
        :required="required"
        :value="selectedLabel"
        readonly
        @input="update"
        @focus="openDropdown"
      >
      <div
        :class="{show: isVisible}"
        aria-labelledby="dropdownMenuButton"
        class="dropdown-menu col-12"
      >
        <div class="vuestic-scrollbar">
          <div class="scrollbar-wrapper">
            <div
              class="scrollbar-content"
              style="position: relative;">
              <div class="dropdown-menu-content">
                <div
                  v-for="option in options"
                  v-show="!option.hide"
                  :key="optionValue(option)"
                  class="dropdown-item"
                  @click="select(option)"
                >
                  <span class="ellipsis">{{ optionLabel(option) }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway2'
export default {
  name: 'FieldSelect',

  directives: { onClickaway },

  props: {
    value: {
      required: true,
      type: [Object, String]
    },

    name: {
      required: true,
      type: [String, Number]
    },

    label: {
      required: false,
      type: String,
      default: ''
    },

    required: {
      type: Boolean,
      default: false
    },

    disabled: {
      type: Boolean,
      default: false
    },

    options: {
      required: true,
      type: Array,
      validator (options = []) {
        options.forEach((option) => {
          if (typeof option === 'object') {
            if (!option.value) {
              console.warn('Option must have "value": ', option)
              return false
            }
            if (!option.label) {
              console.warn('Option must have "label": ', option)
              return false
            }
          } else if (typeof option !== 'string') {
            console.warn('Option must be an object or a string', option)
            return false
          }
        })
        return true
      }
    }
  },

  data () {
    return {
      isVisible: false
    }
  },

  computed: {
    selectedValue () {
      if (typeof this.value === 'object') {
        return this.value.value
      }
      return this.value
    },
    selectedLabel () {
      if (typeof this.value === 'object') {
        return this.value.label
      }
      return this.value
    }
  },

  methods: {
    optionValue (option) {
      if (typeof option === 'object') {
        return option.value
      }
      return option
    },

    optionLabel (option) {
      if (typeof option === 'object') {
        return option.label
      }
      return option
    },

    openDropdown () {
      this.isVisible = true
    },

    closeDropdown () {
      this.isVisible = false
    },

    select (option) {
      var label
      if (typeof option === 'object') {
        label = option.label
      } else {
        label = option
      }
      this.$refs.input.value = label
      this.update(option)
    },

    update (option) {
      var value
      if (typeof option === 'object') {
        value = option.value
      } else {
        value = option
      }
      this.$emit('input', value)
      this.closeDropdown()
    }
  }
}
</script>
